import styled from 'styled-components';
import {
  BodyLgBold,
  BodyMedReg,
  TitleLgReg,
  TitleSmReg,
} from '@seed-health/tokens';
import { mqTabletMin, mqXLargeMin } from 'styled/tools/media-queries';

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-32);
  padding: var(--spacing-48) var(--spacing-24);
  background-color: var(--fill-tertiary);

  @media ${mqXLargeMin} {
    flex-direction: row;
    align-items: center;
    gap: var(--spacing-48);
    padding: var(--spacing-56) var(--spacing-80);
  }
`;

export const Heading = styled.h2`
  ${TitleSmReg}
  margin: 0;
  color: var(--text-primary);

  @media ${mqXLargeMin} {
    ${TitleLgReg}
    flex-shrink: 0;
    width: 376px;
  }
`;

export const Cards = styled.ul`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--spacing-8);
  margin: 0;
  padding: 0;
  list-style: none;

  @media ${mqTabletMin} {
    grid-template-columns: repeat(4, 1fr);
  }

  @media ${mqXLargeMin} {
    flex: 1;
  }
`;

export const Card = styled.li`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-16);
  padding: var(--spacing-16);
  border-radius: var(--radius-md);
  background-color: var(--fill-secondary);

  @media ${mqXLargeMin} {
    padding: var(--spacing-24);
  }
`;

export const CardText = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-4);
  color: var(--text-primary);
`;

export const Timeframe = styled.p`
  ${BodyMedReg}
  margin: 0;
  color: var(--text-primary);
`;

export const Benefit = styled.p`
  ${BodyLgBold}
  margin: 0;
  color: var(--text-primary);
`;
